import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import TrendingDownRoundedIcon from '@mui/icons-material/TrendingDownRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import DragHandleRoundedIcon from '@mui/icons-material/DragHandleRounded';
import { formatBRL, formatPercent } from '../packageFormat';
import formStyles from './PackageFormPopup.module.css';
import styles from './PriceBlock.module.css';

/** Como o preço do pacote se compara ao valor avulso das sessões (desconto, acréscimo ou igual). */
function Comparison({ price, totalValue, discount }) {
  if (totalValue <= 0) {
    return <p className={styles.hint}>Escolha as sessões para comparar com o valor avulso.</p>;
  }

  if (!price) {
    return <p className={styles.hint}>Digite o preço para ver o desconto sobre o avulso.</p>;
  }

  const numericPrice = Number(price);
  if (discount.difference > 0) {
    return (
      <div className={`${styles.verdict} ${styles.discount}`}>
        <TrendingDownRoundedIcon fontSize="small" />
        <span>Desconto de <strong>{formatBRL(discount.difference)}</strong> ({discount.percentage}%) sobre o avulso</span>
      </div>
    );
  }
  if (numericPrice > totalValue) {
    const extra = numericPrice - totalValue;
    return (
      <div className={`${styles.verdict} ${styles.increase}`}>
        <TrendingUpRoundedIcon fontSize="small" />
        <span>Acima do avulso em <strong>{formatBRL(extra)}</strong> (acréscimo de {formatPercent((extra / totalValue) * 100)}%)</span>
      </div>
    );
  }
  return (
    <div className={`${styles.verdict} ${styles.equal}`}>
      <DragHandleRoundedIcon fontSize="small" />
      <span>Mesmo valor das sessões avulsas</span>
    </div>
  );
}

/** Preço do pacote ("1.200,99") ao lado do valor avulso e do desconto calculado. */
function PriceBlock({ form }) {
  const { formData, priceText, priceError, totalValue, discount, setPrice, formatPriceOnBlur } = form;

  return (
    <div className={styles.wrapper}>
      <div className={styles.row}>
        <label className={formStyles.field}>
          <span className={formStyles.label}>Preço do pacote</span>
          <TextField
            size="small"
            value={priceText}
            onChange={(e) => setPrice(e.target.value)}
            onBlur={formatPriceOnBlur}
            placeholder="0,00"
            required
            error={!!priceError}
            helperText={priceError}
            className={formStyles.input}
            inputProps={{ inputMode: 'decimal', 'aria-label': 'Preço do pacote' }}
            InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
          />
        </label>

        <div className={styles.reference}>
          <span className={styles.referenceLabel}>Valor avulso das sessões</span>
          <span className={styles.referenceValue}>{formatBRL(totalValue)}</span>
        </div>
      </div>

      <Comparison price={formData.price} totalValue={totalValue} discount={discount} />
    </div>
  );
}

export default PriceBlock;
